import { Examples } from '@/types';

export const ExampleMStoreOrderableTableRoutes =
  process.env.NODE_ENV !== 'production'
    ? [
        {
          ...Examples.ExampleMStoreOrderableTable,
          components: {
            default: () =>
              import(
                /* webpackChunkName: "ExampleMStoreOrderableTableRoutes" */
                '@/views/examples/ExampleMStoreOrderableTable.vue'
              )
          }
        }
      ]
    : [];
